export const typesComplaints = ["naming"];
